// search for <p><wistia-embed id="abc123"></wistia-embed></p> and convert to wista scripts/tags
;(() => {
    const wistiaExternalScript = document.createElement('script');
    wistiaExternalScript.src = 'https://fast.wistia.com/assets/external/E-v1.js';

    window.convertWistiaTagsToEmbedScripts = function() {
        const wistiaScripts = {};
        const tags = document.querySelectorAll(`wistia-embed`);
  
        for (let i = 0; i < tags.length; i++) {
            const tag = tags[i];
            const videoId = tag.getAttribute('id');

            // convert wistia-embed to wistia <span>
            tag.parentElement.innerHTML = Handlebars.templates['partials/wistia-embed']({ videoId });

            // prevents duplicate scripts
            wistiaScripts[videoId] = tag;
        }
        
        applyWistiaScripts(wistiaScripts);
    }

    function applyWistiaScripts(wistiaScripts) {
        for (const videoId in wistiaScripts) {
            const wistiaVideoScript = document.createElement('script');
            wistiaVideoScript.src= `https://fast.wistia.com/embed/medias/${videoId}.jsonp`;
            wistiaVideoScript.id = "wistia-id-"+ videoId;

            document.body.appendChild(wistiaVideoScript);
        }

        if (Object.keys(wistiaScripts).length && !wistiaExternalScript.parentElement) {
            document.body.appendChild(wistiaExternalScript);
        }
    }
})();